import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { apiEndpoint } from "../../urls";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";

const CLIENT_ID = process.env.REACT_APP_ONEDRIVE_CLIENT_ID;
const REDIRECT_URI = apiEndpoint.esignBaseUri;
console.log(CLIENT_ID)
const OneDrivePicker = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  
  const handleFilePicker = () => {
    if (!window.OneDrive || typeof window.OneDrive.open !== "function") {
      alert("OneDrive SDK not loaded yet. Please wait a moment and try again.");
      return;
    }
  
    const odOptions = {
      clientId: CLIENT_ID,
      action: "download",
      multiSelect: false,
      advanced: {
        filter: ".pdf",
      },
      success: async (files) => {
        console.log("Selected File:", files);
        const fileUrl = files.value[0]?.["@microsoft.graph.downloadUrl"];
        const fileName = files.value[0]?.name;
        if (fileUrl) {
          downloadAndUpload(fileUrl, fileName);
        }
      },
      cancel: () => {
        console.log("User cancelled file selection.");
      },
      error: (e) => {
        console.error("OneDrive Picker Error:", e);
      },
    };
  
    window.OneDrive.open(odOptions);
  };
  

  const downloadAndUpload = async (fileUrl, fileName) => {
    try {
      const response = await fetch(fileUrl);
      const fileBlob = await response.blob();
      uploadToServer(fileBlob, fileName);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const uploadToServer = async (file, fileName) => {
    const formData = new FormData();
    formData.append("file", file, fileName);

    try {
      setLoader(true)
      dispatch(uploadDocument({ token: pdfEditortoken?.access, file }));
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  return (<>
    <Box textAlign="center" onClick={handleFilePicker} sx={{ cursor: "pointer" }}>
      <Box component="img" src={`${process.env.PUBLIC_URL}/images/one-drive.svg`} alt="OneDrive" />
      <Typography variant="body1" fontSize={14} fontWeight={500} mt={1} color="#222222">
        OneDrive
      </Typography>
    </Box>
    {loader && < Loader />}
    </>
  );
};

export default OneDrivePicker;
